/**
 * Arquivo que gerencia a árvore com os módulos e permissões.
 * @author: adalto.junior
 * Date: 23/09/13
 * Time: 09:24
 */


Greenmile.GroupPermissions = Greenmile.GroupPermissions || {};

Greenmile.GroupPermissions.TreeViewPermissions = function () {

    var nodeTypes        = {
            MODULE: 'moduleParent',
            USERINTERFACE: 'userInterface',
            PERMISSION: 'permission'
        },
        selectorTreeView = '#GroupPermissions #treeView';

    var formatNodes = function (nodesToFormat) {

        var error                = null,
            modulesLength        = 0,
            userInterfacesLength = 0,
            nodesFormatted       = [];

        try {

            if (nodesToFormat) {

                modulesLength = nodesToFormat.length;

                for (var i = 0; i < modulesLength; i++) {

                    var nodeParent     = null,
                        module         = nodesToFormat[i],
                        userInterfaces = module.userInterfaces;

                    nodeParent = {
                        "attr": {
                            "id": module.id,
                            'class': nodeTypes.MODULE
                        },
                        "data": module.name,
                        "state": "open",
                        children: []

                    };

                    userInterfacesLength = userInterfaces.length;

                    for (var j = 0; j < userInterfacesLength; j++) {

                        var nodeUserInterface = null,
                            userInterface     = userInterfaces[j],
                            permissions       = userInterface.permissions;

                        nodeUserInterface = {
                            "attr": {
                                "id": userInterface.id,
                                "active": userInterface.active,
                                'class': nodeTypes.USERINTERFACE
                            },
                            "data": userInterface.name,
                            "state": "open",
                            children: []
                        };

                        for (var k = 0; k < permissions.length; k++) {

                            var nodePermission = null,
                                permission     = permissions[k],
                                className      = nodeTypes.PERMISSION;

                            if (permission.active) {
                                className += ' jstree-checked';
                            } else {
                                className += ' jstree-unchecked';
                            }

                            nodePermission = {
                                "attr": {
                                    "id": permission.id,
                                    "class": className
                                },
                                "data": permission.name,
                                "state": "open"
                            };

                            nodeUserInterface.children.push(nodePermission);

                        }

                        nodeParent.children.push(nodeUserInterface);

                    }

                    nodesFormatted.push(nodeParent);

                }

            }

            return nodesFormatted;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on render format nodes.');
            error.console();

        }

    };

    var getStatusCheckedByClassName = function (className) {

        var error  = null,
            result = '';

        try {

            if (className.indexOf('jstree-checked') !== -1) {

                result = 'checked';

            } else if (className.indexOf('jstree-undetermined') !== -1) {

                result = 'partial';

            } else if (className.indexOf('jstree-unchecked') !== -1) {

                result = 'unchecked';

            }

            return result;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get status checked by class name');
            error.console();

        }


    };

    var getNodeTypeByClassName = function (className) {

        var error  = null,
            result = '';

        try {

            if (className.indexOf(nodeTypes.MODULE) !== -1) {

                result = nodeTypes.MODULE;

            } else if (className.indexOf(nodeTypes.USERINTERFACE) !== -1) {

                result = nodeTypes.USERINTERFACE;

            } else if (className.indexOf(nodeTypes.PERMISSION) !== -1) {

                result = nodeTypes.PERMISSION;

            }

            return result;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get node type by class name');
            error.console();

        }


    };

    var getTranslatedKeyByStatusPermission = function (className) {

        var error                   = null,
            i18n                    = Monet.I18n,
            isPermission            = false,
            isModule                = false,
            isUserInterface         = false,
            keyModuleAllChecked     = 'Greenmile.GroupPermission.moduleAllChecked',
            keyModuleParcialChecked = 'Greenmile.GroupPermission.modulePartialChecked',
            keyModuleAllUnChecked   = 'Greenmile.GroupPermission.moduleAllUnChecked',
            keyPermissionsChecked   = 'Greenmile.GroupPermission.permissionChecked',
            keyPermissionsUnChecked = 'Greenmile.GroupPermission.permissionUnChecked',
            keyTranslated           = '',
            statusChecked           = '',
            nodeType                = '';

        try {

            nodeType = getNodeTypeByClassName(className);
            isModule = nodeType === nodeTypes.MODULE;
            isUserInterface = nodeType === nodeTypes.USERINTERFACE;
            isPermission = nodeType === nodeTypes.PERMISSION;

            statusChecked = getStatusCheckedByClassName(className);

            if (isModule || isUserInterface) {

                if (statusChecked === 'checked') {
                    keyTranslated = i18n.getResourcesByKey(keyModuleAllChecked);
                } else if (statusChecked === 'partial') {
                    keyTranslated = i18n.getResourcesByKey(keyModuleParcialChecked);
                } else {
                    keyTranslated = i18n.getResourcesByKey(keyModuleAllUnChecked);
                }

            } else if (isPermission) {

                if (statusChecked === 'checked') {
                    keyTranslated = i18n.getResourcesByKey(keyPermissionsChecked);
                } else {
                    keyTranslated = i18n.getResourcesByKey(keyPermissionsUnChecked);
                }

            }

            return keyTranslated;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get text label translated.');
            error.console();

        }

    };

    var setTextToCheckboxItem = function (node) {

        var error        = null,
            isChecked    = false,
            itemCheckbox = null;

        try {

            isChecked = node.className.indexOf('jstree-checked') !== -1;

            itemCheckbox = node.querySelector('ins.jstree-checkbox');

            if (itemCheckbox) {

                itemCheckbox.textContent = getTranslatedKeyByStatusPermission(node.className, isChecked);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on set text to checkbox item.');
            error.console();

        }

    };

    var setLabelStatusForPermissions = function (module) {

        var error       = null,
            nodes       = null,
            nodesLength = 0;

        try {

            nodes = module.querySelectorAll('li');
            nodesLength = nodes.length;

            for (var i = 0; i < nodesLength; i++) {

                var node = nodes[i];

                setTextToCheckboxItem(node);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on set label status for permissions");
            error.console();

        }
    };

    var resetEventOfCheckOrUnchecked = function () {

        App.Views.GroupPermissions.renderContainerPermissions(Monet.Session.GroupPermission.groupId);

    };

    var extractValidIds = function (nodesPermissions, isChecked) {

        var ids = [];
        var __nodesPermissions = nodesPermissions;
        var __nodesPermissionsLength = __nodesPermissions.length;

        for (var i = 0; i < __nodesPermissionsLength; i++) {

            var node = __nodesPermissions[i];
            var previousNodeStatus = Greenmile.GroupPermissions.Utils.getStatusPreviousNodeById(node.id);

            if (previousNodeStatus !== isChecked) {
                ids.push(node.id);
            }

        }

        return ids;

    };

    var eventsToCheckOrUnChecked = function (event, data) {

        var error            = null,
            nodeSelected     = null,
            checkBoxElement  = null,
            module           = null,
            router           = null,
            isChecked        = false,
            nodeId           = null,
            userInterface    = null,
            selectorGroupId  = '#GroupPermissions #groupId',
            groupId          = null,
            callbackForError = null,
            nodeType         = '';

        try {

            checkBoxElement = data.args[0];
            nodeSelected = checkBoxElement.parentNode.parentNode;
            isChecked = event.type === 'check_node';

            const cancelAction = () => {
                resetEventOfCheckOrUnchecked(nodeSelected, isChecked);
                App.Views.GroupPermissions.removeMessageError();
            };

            const confirmAction = () => {
                nodeId = nodeSelected.id;

                router = new App.Routers.GroupPermissions();
                nodeType = getNodeTypeByClassName(nodeSelected.className);
                groupId = document.querySelector(selectorGroupId).value;

                callbackForError = function (nodeSelected) {
                    return function () {

                        var treeView = jQuery.jstree._reference(selectorTreeView);
                        treeView.refresh();

                        if ([nodeTypes.MODULE, nodeTypes.USERINTERFACE].indexOf(nodeType) !== -1) {
                            setLabelStatusForPermissions(nodeSelected);
                        }
                        setTextToCheckboxItem(nodeSelected);
                    };
                }(nodeSelected);

                if (nodeType === nodeTypes.MODULE) {

                    setLabelStatusForPermissions(nodeSelected);

                    var isFiltered = Monet.Session.GroupPermission.permissionIsFiltered;

                    if (isFiltered) {

                        var nodes = extractValidIds(nodeSelected.querySelectorAll('.permission'), isChecked);

                        router.updatePermissions(groupId, nodes, isChecked, callbackForError);


                    } else {

                        router.updateAllPermissionsByModule(groupId, nodeId, isChecked, callbackForError);

                    }

                } else {

                    if (nodeType === nodeTypes.USERINTERFACE) {

                        module = nodeSelected.parentNode.parentNode;

                        setLabelStatusForPermissions(nodeSelected);

                        router.updateAllPermissionByUserInterface(groupId, nodeId, isChecked, callbackForError);

                    } else {

                        module = nodeSelected.parentNode.parentNode.parentNode.parentNode;
                        userInterface = nodeSelected.parentNode.parentNode;

                        setTextToCheckboxItem(userInterface);

                        router.updatePermission(groupId, nodeId, isChecked, callbackForError);
                    }

                    setTextToCheckboxItem(module);

                }

                setTextToCheckboxItem(nodeSelected);
            };

            new Greenmile.Components.AlertModal('Greenmile.GroupPermissions.confirmChange',
                null,
                confirmAction,
                cancelAction
            )
            .show();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on events to check or unchecked.", e);
            error.console();

        }
    };

    this.listenerToCheckbox = function () {

        var setCheckBoxLabelOnLoad = function () {

            var module = this;

            setLabelStatusForPermissions(module);

        };

        $(this.selector)
            .on("loaded.jstree", setCheckBoxLabelOnLoad)
            .on("check_node.jstree", eventsToCheckOrUnChecked)
            .on("uncheck_node.jstree", eventsToCheckOrUnChecked)
            .on("refresh.jstree", setCheckBoxLabelOnLoad);

    };

    this.render = function (nodes) {

        var error                 = null,
            treeView              = null,
            nodesFormatted,
            pluginOptionsTreeview = [
                'json_data',
                'crrm',
                'ui',
                'checkbox'
            ];

        try {

            nodesFormatted = formatNodes(nodes);

            treeView = new Greenmile.Treeview(selectorTreeView);
            treeView.eventListenerSelectNode = this.listenerToCheckbox;
            treeView.createTreeView(nodesFormatted, pluginOptionsTreeview);
            treeView.eventListenerSelectNode();
            this.nodes = nodes;
            this.treeView = treeView;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on render treeView.');
            error.console();

        }
    };

};
